define("ember-cli-string-helpers/helpers/uppercase", ["exports", "@ember/component/helper", "ember-cli-string-helpers/utils/uppercase", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _uppercase, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.uppercase = _exports.default = void 0;
  const uppercase = _exports.uppercase = (0, _createStringHelper.default)(_uppercase.default);
  var _default = _exports.default = (0, _helper.helper)(uppercase);
});